import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const EndpointHistoryTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:date')}
        thClassName="min-w-[135px]"
        sortable
        onSortClick={() => onSort?.('createdAt')}
      />
      <TableHead
        text={`${t('common:licensePlateNumber')} & ${t('common:vin')}`}
        thClassName="w-[230px]"
        onSortClick={() => onSort?.('licensePlateAndVin')}
      />
      <TableHead text={t('common:client')} thClassName="w-[215px]" />
      <TableHead
        text={t('endpointHistory:method')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead text={t('endpointHistory:schema')} />
      <TableHead text={t('endpointHistory:urlWithValues')} />
    </>
  );
};
